// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-logo{background-color:var(--background-color);display:flex;justify-content:center;margin-left:auto;margin-right:auto;width:100%}.footer-logo__image{height:8.8571428571rem}@media(min-width:768px){.footer-logo__image{height:10.7142857143rem}}@media(min-width:1440px){.footer-logo__image{height:13.0714285714rem}}", ""]);
// Exports
module.exports = exports;
